import axiosRetry from '../helpers/OurAxiosRetry';

export default {
  resultForFileTransferError,
  resultForError,
  resultForErrorText,
  isNetworkError,
  isIdempotentRequestError,
};

function resultForFileTransferError(error) {
  const offline = (error.http_status && [408, 500, 502, 503, 504].includes(error.http_status)) || (error.code && error.code == window.FileTransferError.CONNECTION_ERR);
  const message = error.exception ? error.exception.toString() : 'code = ' + error.code;
  return { offline: offline, error: message };
}

function resultForError(error) {
  return { offline: isNetworkError(error), error: error };
}

function resultForErrorText(errorText) {
  return { offline: false, error: errorText };
}

function isNetworkError(error) {
  return axiosRetry.isNetworkError(error) || (!error.status && error.message && error.message == 'Network Error');
}

function isIdempotentRequestError(error) {
  return axiosRetry.isIdempotentRequestError(error);
}



// WEBPACK FOOTER //
// ./src/services/serviceUtil.js